export default class BookingInvoiceManager {

    constructor() {
        this.userFormInvoiceData = [];
        this.fillInvoiceNowClicked = 1;
        this.bookingForm = $("#bookingForm");
        this.bookingInvoiceInputs = $('#form-request-invoice input, #form-request-invoice select');
        this.eventDelegation();
        this.checkRequestInvoice('[name="request-invoice"]');
        this.checkInvoiceFormat(':checked[name="invoice_format"]')
        this.checkSendOtherAddress('[name="send-other-address"]');
    };

    eventDelegation() {
        $('[name="request-invoice"]').on("change", (event) => {
            this.checkRequestInvoice(event.currentTarget);
        });

        $('[name="send-other-address"]').on("change", (event) => {
            this.checkSendOtherAddress(event.currentTarget);
        });

        $('[name="invoice_format"]').on("change", (event) => {
            this.checkInvoiceFormat(event.currentTarget);
        });

        this.bookingForm.on("click", "[data-field='fill-same-data']", (e) => {
            if (this.fillInvoiceNowClicked) {
                this.saveFormRequestBookingInvoice();
            }

            $("#country-code option[value='ES']").prop("selected", true);
            this.copyBookingFormToInvoiceForm();
            $("#form-request-invoice").show();
            this.fillInvoiceNowClicked = 0;
            myApp.form.formPrinter.revalidateFieldsContainer(this.bookingInvoiceInputs);
        });

        this.bookingForm.on("click", "[data-field='fill-now']", (e) => {
            this.fillFormRequestInvoice();
            myApp.form.formPrinter.toggleValidateFieldsContainer("#form-request-invoice [data-field='invoice']", true);
            $("#form-request-invoice").show();
            this.fillInvoiceNowClicked = 1;
            myApp.form.formPrinter.revalidateFieldsContainer(this.bookingInvoiceInputs);
        });

        $('[name="id-type"]').on('change', () => {
            const idType = $('[name="id-type"]').val();
            const dniInput = $('#dni_nif');

            dniInput.val(idType);
            dniInput.change();
        });
    };

    checkInvoiceFormat(element) {
        if ($(element).length === 0) {
            return;
        }
        if ($(element).val() === 'paper') {
            $('[data-container="send-invoice-other-address"]').show();
            myApp.form.formPrinter.toggleValidateFieldsContainer("#form-request-invoice [data-field='invoice-send']", true);
        } else {
            $('[data-container="send-invoice-other-address"]').hide();
            myApp.form.formPrinter.toggleValidateFieldsContainer("#form-request-invoice [data-field='invoice-send']", false);
        }
    };

    checkSendOtherAddress(element) {
        if ($(element).length === 0) {
            return;
        }

        if ($(element).is(':checked')) {
            myApp.form.formPrinter.toggleValidateFieldsContainer("#form-request-invoice [data-field='invoice-send']", true);
            $('#container-booking-invoice-address').slideDown();
        } else {
            myApp.form.formPrinter.toggleValidateFieldsContainer("#form-request-invoice [data-field='invoice-send']", false);
            $('#container-booking-invoice-address').slideUp();
        }
    };

    checkRequestInvoice(element) {
        if ($(element).length === 0) {
            return;
        }

        if ($(element).is(':checked')) {
            myApp.form.formPrinter.toggleValidateFieldsContainer("#form-request-invoice [data-field='invoice']", true);
            $("#form-request-invoice").show();
            this.fillInvoiceNowClicked = 1;
            $('#container-booking-invoice').slideDown();
        } else {
            myApp.form.formPrinter.toggleValidateFieldsContainer("#form-request-invoice [data-field='invoice']", false);
            $('#container-booking-invoice').slideUp();
        }
    };

    fillFormRequestInvoice() {
        $.each($("#form-request-invoice").find("input, select"), (i, input) => {
            $(input).val("");
        });

        $("[name=dni_nif] option[value='CIF']").prop("selected", true);
        $("[name=codi_pais] option[value='ES']").prop("selected", true);
    };

    copyBookingFormToInvoiceForm() {
        const firstName = $("[name=titular_nombre]").val();
        const clientName = firstName + " " + $("[name=titular_1]").val();
        const originCountry = $("#bookingForm [name=country]").val();
        if (firstName !== "") {

            $("[name=client]").val(clientName);
            $("[name=client_country]").val(originCountry);
            $("[name=client_nif]").val($("[name=dni]").val());
        }
    };

    saveFormRequestBookingInvoice() {
        const inputsFormRequestInvoice = $("#form-request-invoice").find("input, select");
        $.each(inputsFormRequestInvoice, (i, input) => {
            const inputId = $(input).attr("id");
            this.userFormInvoiceData[inputId] = $(input).val();
        });
    };
}
